import { AxiosRequestConfig } from 'axios'
const axiosConfig: AxiosRequestConfig = {
  baseURL: '/',
  // responseType: 'json',
  // 超时设置s
  timeout: 30000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  },
}

export default axiosConfig
